import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FnImageComponent } from './fn-img-upload-component';

export * from './fn-img-upload-component';
/**
 * Exports the required FnImgUploadModule to create a component that is used to upload image and show image on UI.
 * making them available for import by NgModules that import this module.
 */

@NgModule({
	declarations: [FnImageComponent],
	imports: [CommonModule],
	exports: [FnImageComponent],
	schemas: [],
})
export class FnImgUploadModule {}
